export default "__VITE_ASSET__DZKakZMJ__"